import { CellProps } from '@/components/bulkQueue/types';
import { VerticalStack } from '@/components/utils/linearLayouts';
import { addressInOneLine, basicAddressToAddress } from '@/utils/addresses';
import { Typography } from '@mui/material';
import { FC } from 'react';

export const PatientRenderCell: FC<CellProps> = (props) => {
    const { entity } = props;

    return (
        <VerticalStack>
            <Typography fontSize={'14px'}>{entity.patient.fullName}</Typography>
            {entity.address && (
                <Typography fontSize={'12px'}>
                    {addressInOneLine(basicAddressToAddress(entity.address))}
                </Typography>
            )}
        </VerticalStack>
    );
};
